import { AgxTypography } from '@urbanx/agx.ui-components2';
import type { ReactNode } from 'react';

interface AutomationFailureDetailRowProps {
  id: string;
  label: string;
  children: ReactNode;
  compact?: boolean;
}

const AutomationFailureDetailRow = ({
  id,
  label,
  children,
  compact = false,
}: AutomationFailureDetailRowProps) => (
  <div
    className={`automationFailureDetailRow${compact ? ' automationFailureDetailRowCompact' : ''}`}
  >
    <AgxTypography
      id={`${id}-label`}
      type="body_ui"
      size="small"
      color="var(--text-tertiary)"
      noWrap
    >
      {label}
    </AgxTypography>
    <div className="automationFailureDetailValue">
      {typeof children === 'string' ? (
        <AgxTypography id={`${id}-value`} type="body_ui" size="small">
          {children}
        </AgxTypography>
      ) : (
        children
      )}
    </div>
  </div>
);

export default AutomationFailureDetailRow;
